"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentMetadataNode = exports.CurrentFullCommandDataNode = exports.CurrentCommandDataNode = exports.CurrentFormValueNode = exports.CurrentFormNode = exports.CurrentEventNode = exports.CurrentAggregateStateNode = void 0;
const AccessorBaseNode_1 = require("./AccessorBaseNode");
/**
 * This provides all of the basic known input nodes used throughout the system
 */
class CurrentAggregateStateNode extends AccessorBaseNode_1.AccessorBaseNode {
    constructor(
    // required options for running the transform node
    init, 
    // options only needed for design time
    design) {
        super('STATE', 'STATE', init, design);
    }
}
exports.CurrentAggregateStateNode = CurrentAggregateStateNode;
CurrentAggregateStateNode._nodeDefinition = {
    NODE_TYPE: 'STATE',
    defaultTitle: 'Current Aggregate State',
    isIdempotent: true,
    primaryCategory: 'Input Data',
};
class CurrentEventNode extends AccessorBaseNode_1.AccessorBaseNode {
    constructor(
    // required options for running the transform node
    init, 
    // options only needed for design time
    design) {
        super('EVENT', 'EVENT', init, design);
    }
}
exports.CurrentEventNode = CurrentEventNode;
CurrentEventNode._nodeDefinition = {
    NODE_TYPE: 'EVENT',
    defaultTitle: 'Current Event',
    isIdempotent: true,
    primaryCategory: 'Input Data',
};
class CurrentFormNode extends AccessorBaseNode_1.AccessorBaseNode {
    constructor(
    // required options for running the transform node
    init, 
    // options only needed for design time
    design) {
        super('FORM', 'FORM', init, design);
    }
}
exports.CurrentFormNode = CurrentFormNode;
CurrentFormNode._nodeDefinition = {
    NODE_TYPE: 'FORM',
    defaultTitle: 'Current Form',
    isIdempotent: true,
    primaryCategory: 'Input Data',
};
class CurrentFormValueNode extends AccessorBaseNode_1.AccessorBaseNode {
    constructor(
    // required options for running the transform node
    init, 
    // options only needed for design time
    design) {
        super('FORMVALUE', 'FORMVALUE', init, design);
    }
}
exports.CurrentFormValueNode = CurrentFormValueNode;
CurrentFormValueNode._nodeDefinition = {
    NODE_TYPE: 'FORMVALUE',
    defaultTitle: 'Current Form Control Value',
    isIdempotent: true,
    primaryCategory: 'Input Data',
};
class CurrentCommandDataNode extends AccessorBaseNode_1.AccessorBaseNode {
    constructor(
    // required options for running the transform node
    init, 
    // options only needed for design time
    design) {
        super('DATA', 'DATA', init, design);
    }
}
exports.CurrentCommandDataNode = CurrentCommandDataNode;
CurrentCommandDataNode._nodeDefinition = {
    NODE_TYPE: 'DATA',
    defaultTitle: 'Command Data',
    isIdempotent: true,
    primaryCategory: 'Input Data',
};
class CurrentFullCommandDataNode extends AccessorBaseNode_1.AccessorBaseNode {
    constructor(
    // required options for running the transform node
    init, 
    // options only needed for design time
    design) {
        super('COMMAND_DATA', 'COMMAND_DATA', init, design);
    }
}
exports.CurrentFullCommandDataNode = CurrentFullCommandDataNode;
CurrentFullCommandDataNode._nodeDefinition = {
    NODE_TYPE: 'COMMAND_DATA',
    defaultTitle: 'Full Command Data',
    isIdempotent: true,
    primaryCategory: 'Input Data',
};
class CurrentMetadataNode extends AccessorBaseNode_1.AccessorBaseNode {
    constructor(
    // required options for running the transform node
    init, 
    // options only needed for design time
    design) {
        super('METADATA', 'METADATA', init, design);
    }
}
exports.CurrentMetadataNode = CurrentMetadataNode;
CurrentMetadataNode._nodeDefinition = {
    NODE_TYPE: 'METADATA',
    defaultTitle: 'Current Metadata',
    isIdempotent: true,
    primaryCategory: 'Input Data',
};
//# sourceMappingURL=InputNodes.js.map